module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumeEditor"
    }
  }, [_vm._v("\n  I am resumeEditor\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53358100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumeEditor.vue
// module id = 23
// module chunks = 0